export default __webpack_public_path__ + "static/media/solucao-06.62b31d67.webp";